import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { AppState } from './types';
import useOverstepPage from '@ids/pages/overstep/useOverstepPage';
import { PATHS } from '@ids/router/routes';

export const initialAppState = {
    idsPath: '/m/westwingstudio/',
    location: {
        pathname: '/m/westwingstudio/',
        hash: '',
        search: '',
        state: undefined,
    },
    history: null,
};

const AppContext = React.createContext<AppState>(initialAppState);

type AppProviderProps = React.PropsWithChildren<RouteComponentProps<{ path: string }>>;

const isOverstepPage = (pathname: string) => pathname.match(PATHS.OVERSTEP);

const AppProvider = withRouter(({ match: { path }, location, history, children }: AppProviderProps) => {
    const { hasRedirectToOverstepCookie, checkIfRedirectsToOverstep } = useOverstepPage();

    const memoizedValue = React.useMemo(() => ({ idsPath: path, location, history }), [path, location, history]);

    if (!isOverstepPage(location.pathname) && hasRedirectToOverstepCookie()) {
        checkIfRedirectsToOverstep(location.pathname);
        return null;
    }

    return <AppContext.Provider value={memoizedValue}>{children}</AppContext.Provider>;
});

AppContext.displayName = 'AppContext';

const useAppContext = () => {
    const context = React.useContext(AppContext);

    if (!context) {
        throw new Error('useAppContext must be used within a AppContextProvider');
    }

    return context;
};

export { AppProvider, useAppContext };
